import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import './styles.css'

// Note: intentionally no React.StrictMode. Its dev-only mount→unmount→remount
// double-invoke fights Leaflet map initialization and the Yjs websocket
// lifecycle; the production behavior is unaffected.
createRoot(document.getElementById('root')).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
)
